import { ButtonCus } from '@/components/common/Button';
import Combobox from '@/components/common/Combobox';
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/components/common/Form';
import { REFUND_STATUS_DATA } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import yup from '@/services/yup';
import { REFUND_STATUS } from '@/types/enums';
import { UpdateReservationRequest } from '@/types/http-payload/reservation';
import { yupResolver } from '@hookform/resolvers/yup';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface UpdateCancelOrderProps {
    id: number,
    reload?: Function
}
export default observer(function UpdateCancelOrder({ id, reload }: UpdateCancelOrderProps) {
    // hook
    const { t } = useTranslation();

    // store
    const { reservationStore: { updateReservation, getReservationCMSDetail }, modalStore: { hideAllModals, showAlertModal } } = useStore();
    // validate schema
    const validateSchema = yup.object().shape({
        refundStatus: yup.number().required(),
        note: yup
            .string()
    });

    type FormData = yup.InferType<typeof validateSchema>;

    // state
    const form = useForm<FormData>({
        resolver: yupResolver(validateSchema),
        mode: 'onChange',
        defaultValues: {
            refundStatus: REFUND_STATUS.Not_Refund,
            note: ''
        }
    });

    const watchRefundStatus = form.watch('refundStatus');
    const watchNote = form.watch('note');

    // lifecycle
    useEffect(() => {
        getDetail();
    }, []);

    // function
    const getDetail = async () => {
        const result = await flowResult(getReservationCMSDetail({ id }));
        if (result) {
            let refundStatus = result.information.refundInfor?.refundStatus || REFUND_STATUS.Not_Refund;

            form.setValue('refundStatus', refundStatus);
        }
    };

    const onSubmit = async (data: FormData) => {
        const payload: UpdateReservationRequest = {
            id,
            note: data.note || '',
            refundStatus: data.refundStatus
        };
        const res = await flowResult(updateReservation(payload));
        if (res) {
            hideAllModals();
            showAlertModal({
                id: 'update-success',
                type: 'success',
                content: t('messages.update_success'),
                onClickXIcon: () => {
                    reload && reload();
                }
            });
        } else {
            showAlertModal({
                id: 'update-fail',
                type: 'error',
                content: t('messages.update_failure')
            });
        }
    };

    const RefundSatusList = Object.keys(REFUND_STATUS_DATA).map(key => ({
        label: t(REFUND_STATUS_DATA[key].key),
        value: REFUND_STATUS_DATA[key].value.toString(),
        code: REFUND_STATUS_DATA[key].value.toString()
    }));

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
                <div>
                    <FormField
                        control={form.control}
                        name='refundStatus'
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>{t('field.refund_status')}</FormLabel>
                                <FormControl>
                                    <Combobox
                                        value={field.value?.toString() ?? ''}
                                        onChange={(item) => {
                                            field.onChange(item?.value);
                                        }}
                                        disableClearIcon
                                        disabled={field.value === REFUND_STATUS.Refund}
                                        items={
                                            RefundSatusList
                                        }
                                    />
                                </FormControl>
                            </FormItem>
                        )}
                    />
                </div>
                {/* <div className='mt-4'>
                    <FormField
                        control={form.control}
                        name='note'
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>{t('words_title.note')}</FormLabel>
                                <FormControl>
                                    <Textarea {...field} rows={5} maxLength={500} placeholder={t('placeholder.enter')}></Textarea>
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                </div> */}
                <div>
                    <div className='mt-8 flex justify-center'>
                        <ButtonCus variant='default' disabled={form.formState.isSubmitting || (watchRefundStatus === REFUND_STATUS.Refund && (!watchNote || !watchNote.trim()))} size='sm' type='submit'>{t('button.send')}</ButtonCus>
                    </div>
                </div>
            </form>
        </Form>
    );
});
